import { useEffect, useRef, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Navbar, Nav } from "react-bootstrap";
import { useAuth } from "../pages/login/AuthProvider";
import "../styles/navbar.scss";

export default function MNavbar() {
  const { authorized, chinese_name, account, logout } = useAuth();

  const displayName =
    (!chinese_name || chinese_name === account)
      ? (account?.split("@")[0] ?? "")
      : chinese_name;

  const [showNavbar, setShowNavbar] = useState(true);
  const lastYRef = useRef(0);
  const tickingRef = useRef(false);

  useEffect(() => {
    const onScroll = () => {
      if (!tickingRef.current) {
        window.requestAnimationFrame(() => {
          const currentY = window.scrollY;
          const goingDown = currentY > lastYRef.current;

          if (goingDown && currentY > 80) {
            setShowNavbar(false);
          } else {
            setShowNavbar(true);
          }

          lastYRef.current = currentY;
          tickingRef.current = false;
        });
        tickingRef.current = true;
      }
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <Navbar
      expand="xl"
      variant="dark"
      fixed="top"
      className={`custom-navbar ${showNavbar ? "show" : "hide"}`}
      style={{ backgroundColor: "#152046", transition: "transform 0.3s ease" }}
    >
      <div className="container d-flex align-items-center">

        {/* 左邊 Logo */}
        <NavLink className="navbar-brand logo me-3" to="/">
          <img src="/logo/logo.svg" alt="Logo" />
        </NavLink>

        {/* 👉 手機版右側：耳機 + 會員 + 漢堡（xl 以下才會顯示） */}
        <div className="d-flex align-items-center ms-auto d-xl-none">
          {/* 耳機 icon */}
          <a
            href="https://a310.itraining.tw/"
            className="me-3 text-white"
            target="_blank"
            rel="noreferrer"
          >
            <i className="fa-solid fa-headphones" />
          </a>

          {/* 會員 icon（登入 / 未登入） */}
          {authorized ? (
            <div className="d-flex align-items-center text-white me-2">
              <NavLink to="/member" className="text-white me-2">
                <i className="fa-solid fa-user" />
              </NavLink>
            </div>
          ) : (
            <Link to="/member/memberlogin" className="text-white me-2">
              <i className="fa-solid fa-user" />
            </Link>
          )}

          {/* 手機版漢堡按鈕 */}
          <Navbar.Toggle aria-controls="mnavbarScroll" />
        </div>

        {/* 展開的內容（主選單 + 桌機版右側區塊） */}
        <Navbar.Collapse id="mnavbarScroll" className="flex-grow-1">
          {/* 中間主選單 */}
          <Nav className="mx-auto d-flex flex-column flex-xl-row align-items-xl-center">
            <Nav.Item>
              <NavLink className="nav-link" to="/about/origin">
                關於捷進
              </NavLink>
            </Nav.Item>
            <Nav.Item>
              <NavLink className="nav-link" to="/becker">
                美國 Becker
              </NavLink>
            </Nav.Item>
            <Nav.Item>
              <NavLink className="nav-link" to="/cpa">
                國際證照考試
              </NavLink>
            </Nav.Item>
            <Nav.Item>
              <NavLink className="nav-link" to="/service">
                服務項目
              </NavLink>
            </Nav.Item>
            <Nav.Item>
              <Link className="nav-link" to="/share">
                成功案例
              </Link>
            </Nav.Item>
            <Nav.Item>
              <Link className="nav-link" to="/video">
                影音專區
              </Link>
            </Nav.Item>
            <Nav.Item>
              <Link className="nav-link" to="/faq">
                FAQ
              </Link>
            </Nav.Item>
          </Nav>

          {/* 👉 桌機版右側：耳機 + 會員（只有 xl 以上顯示） */}
          <div className="d-none d-xl-flex align-items-center ms-3 text-white">
            <a
              href="https://a310.itraining.tw/"
              className="me-3 text-white"
              target="_blank"
              rel="noreferrer"
            >
              <i className="fa-solid fa-headphones" />
            </a>

            {authorized ? (
              <div className="d-flex align-items-center">
                <NavLink to="/member" className="text-white me-3">
                  <i className="fa-solid fa-user" />
                  
                </NavLink>
                <div className="memname me-3">{displayName}</div>
                <div
                  className="text-white logouttext"
                  onClick={() => logout()}
                  style={{ cursor: "pointer" }}
                >
                  登出
                </div>
              </div>
            ) : (
              <Link to="/member/memberlogin" className="text-white">
                <i className="fa-solid fa-user" />
              </Link>
            )}
          </div>
        </Navbar.Collapse>
      </div>
    </Navbar>
  );
}
